import { useTranslation } from 'react-i18next';

import { IconName } from '@/components/icons/types';
import { useDevelopmentStatus, useSaleOptions } from '@/hooks';

import { OpportunityDetails, OpportunityItemList } from '../../../types';
import { HeaderCards } from '@/components/header-cards';
import { useLocation } from '@/features/projects';
import { formatCapacity, getCapacityTitle, getLocationTitle } from '@/features/opportunities/helpers';

export type OpportunityCardsProps = {
  readonly opportunity: OpportunityDetails | OpportunityItemList;
};

export function OpportunityCards({ opportunity }: OpportunityCardsProps) {
  const { t } = useTranslation(['opportunities']);
  const { kv: developmentStatus } = useDevelopmentStatus();
  const location = useLocation({ location: opportunity.location });
  const { map: mapSaleOption } = useSaleOptions();
  const saleOptions = (opportunity?.options ?? []).map(mapSaleOption).join(', ');

  const isTopco = opportunity.technologies.types.includes('topco');
  const techTypes = opportunity.technologies.types;
  const capacity = opportunity.technologies.capacity;

  const infoCards = [
    {
      icon: 'lightning' as IconName,
      title: getCapacityTitle(techTypes, t),
      value: formatCapacity(techTypes, capacity, opportunity.totalMw),
    },
    {
      icon: 'location' as IconName,
      title: getLocationTitle(techTypes, t),
      value: location,
    },
    ...(!isTopco
      ? [
          {
            icon: 'waypoints' as IconName,
            title: t('Development status'),
            value: opportunity.technologies.state.list.map((status) => developmentStatus[status]).join(', '),
          },
        ]
      : [
          {
            icon: 'waypoints' as IconName,
            title: t('Company Type'),
            value: opportunity.companyType ?? '-',
          },
        ]),
    { icon: 'handshake' as IconName, title: t('Deal Type'), value: saleOptions },
  ];

  return <HeaderCards info={infoCards} />;
}
